import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../reports/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_SCREEN_API_URL);

export const stringifyParams = params => qs.stringify(params, { encodeValuesOnly: true });

// Report
export const getReportList = () => apiClient.get(url.GET_REPORTS);
export const getReport = report => apiClient.get(url.REPORTS + '/' + encodeURIComponent(report));
export const addNewReport = report => apiClient.post(url.ADD_REPORTS, report);
export const updateReport = report => apiClient.put(url.UPDATE_REPORTS + '/' + report._id, report);
export const deleteReport = report => apiClient.delete(url.DELETE_REPORTS + '/' + report._id);